"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderShape = exports.renderFullBgHeroImage = void 0;
var _fpoSquare = _interopRequireDefault(require("../../images/fpo-square.png"));
var _react = _interopRequireDefault(require("react"));
var _generateFocusedImageAlt = _interopRequireDefault(require("../../utils/generateFocusedImageAlt"));
var _renderImageOrLottieAnimation = require("../../utils/renderImageOrLottieAnimation");
var _FocusedImage = _interopRequireDefault(require("../FocusedImage/FocusedImage"));
var _Image = _interopRequireDefault(require("../Image/Image"));
var _LottieAnimation = _interopRequireDefault(require("../LottieAnimation/LottieAnimation"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const imageBackgroundSizes = {
  "variant-1": {
    desktop: {
      width: 2400,
      height: 1350,
      ratio: {
        width: 16,
        height: 9
      }
    },
    tablet: {
      width: 1200,
      height: 560,
      ratio: {
        width: 15,
        height: 7
      }
    },
    mobile: {
      width: 600,
      height: 467,
      ratio: {
        width: 9,
        height: 7
      }
    }
  },
  "variant-2": {
    desktop: {
      width: 2400,
      height: 727,
      ratio: {
        width: 33,
        height: 10
      }
    },
    tablet: {
      width: 960,
      height: 480,
      ratio: {
        width: 2,
        height: 1
      }
    },
    mobile: {
      width: 360,
      height: 280,
      ratio: {
        width: 9,
        height: 7
      }
    }
  },
  "variant-2-inset": {
    desktop: {
      width: 2400,
      height: 727,
      ratio: {
        width: 33,
        height: 10
      }
    },
    tablet: {
      width: 960,
      height: 480,
      ratio: {
        width: 2,
        height: 1
      }
    },
    mobile: {
      width: 360,
      height: 280,
      ratio: {
        width: 9,
        height: 7
      }
    }
  },
  "variant-3": {
    desktop: {
      width: 2400,
      height: 727,
      ratio: {
        width: 33,
        height: 10
      }
    },
    tablet: {
      width: 960,
      height: 480,
      ratio: {
        width: 2,
        height: 1
      }
    },
    mobile: {
      width: 600,
      height: 467,
      ratio: {
        width: 9,
        height: 7
      }
    }
  },
  content: {
    desktop: {
      width: 480,
      height: 480,
      ratio: {
        width: 1,
        height: 1
      }
    },
    tablet: {
      width: 300,
      height: 300,
      ratio: {
        width: 1,
        height: 1
      }
    },
    mobile: {
      width: 280,
      height: 280,
      ratio: {
        width: 1,
        height: 1
      }
    }
  }
};
const backgroundImageSize = (backgroundImage, size) => {
  return backgroundImage?.image[size] || backgroundImage?.image["desktop"];
};
const renderImageComponent = (image, size) => {
  return /*#__PURE__*/_react.default.createElement(_Image.default, {
    src: size ? backgroundImageSize(image, size)?.src : image?.image?.src || _fpoSquare.default,
    alt: size ? backgroundImageSize(image, size)?.alt : image?.image?.alt || "placeholder image",
    className: "luna-full-background-hero__image",
    onError: e => {
      e.target.onerror = null;
      e.target.src = _fpoSquare.default;
    },
    lazyLoad: image?.lazyLoad
  });
};
const renderFullBgHeroImage = function (image) {
  let size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  let variant = arguments.length > 2 ? arguments[2] : undefined;
  let elementClass = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  let lottieRatio = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  const imageType = image?.type || "default";
  const lottieStyles = {};
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, imageType === "image" && renderImageComponent(image, size), imageType != "image" && (0, _renderImageOrLottieAnimation.renderImageOrLottieAnimation)(imageType === 'focalPointImage' ? image?.focalPointImage : image, null, variant ? imageBackgroundSizes[variant] : null, (0, _generateFocusedImageAlt.default)(image), elementClass, lottieStyles, true, lottieRatio, image?.lazyLoad));
};
exports.renderFullBgHeroImage = renderFullBgHeroImage;
const renderShape = (shapeBorderColor, rightImage, shapeType, size, variant) => {
  const lottieRatio = shapeType === "square" ? {
    height: 1,
    width: 1
  } : null;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      borderColor: shapeBorderColor,
      background: shapeBorderColor
    },
    className: `
                luna-full-background-hero__content-wrapper-right-figure
                luna-full-background-hero__content-wrapper-right-figure--${shapeType}`,
    "data-sb-object-id": rightImage?.contentfulId ? rightImage.contentfulId : null
  }, renderFullBgHeroImage(rightImage, size, variant, null, lottieRatio));
};
exports.renderShape = renderShape;